import React from "react";
import Box from "../../molecules/Box";
import { FieldLabel, FieldValue } from "../../molecules/Typography";
import { useStyles } from "./Field.styles";

export interface FieldProps {
  label: string;
  value: string;
  className?: string;
}

const Field = ({ label, value, className }: FieldProps) => {
  const classes = useStyles();
  return (
    <Box className={`${classes.root}${className ? ` ${className}` : ""}`}>
      <FieldLabel className={classes.label}>{label}</FieldLabel>
      <FieldValue className={classes.value}>{value}</FieldValue>
    </Box>
  );
};

export default Field;
